import { z } from 'zod';
import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';
import { isNil } from 'lodash';
import { Offer_Fulfillment_Operator } from '@occc/graphql';
import { OfferFulfillment } from '../../types';

export const fulfillmentSchema = z
  .array(
    z
      .object({
        fulfilled: z.nativeEnum(OfferFulfillment),
        operator: z.nativeEnum(Offer_Fulfillment_Operator).optional().nullable(),
        timesFulfilled: z.number().optional(),
        targetOffer: z.object({}).passthrough().optional().nullable(),
      })
      .superRefine((data, ctx) => {
        const { targetOffer, fulfilled, operator, timesFulfilled } = data;
        const hasTargetOffer = targetOffer && Object.keys(targetOffer).length > 0;
        const isFulfilled = fulfilled === OfferFulfillment.Fulfilled;
        if (hasTargetOffer && isFulfilled && !operator) {
          ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['operator'], message: IS_REQUIRED });
        }
        if (hasTargetOffer && isFulfilled && operator && isNil(timesFulfilled)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['timesFulfilled'],
            message: IS_REQUIRED,
          });
        }
      }),
  )
  .superRefine((items, ctx) => {
    items.forEach((item, index) => {
      if (index !== 0 && !item.targetOffer) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: [index, 'targetOffer'],
          message: IS_REQUIRED,
        });
      }
    });
  });
